import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import './LegalApp.css';
//import bcrypt from "bcryptjs";
import axios from 'axios';

const ResetPassword = ({ API_URL }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const [email, setEmail] = useState(location.state ? location.state.email : '');
    const [showResetPasswordAlert, setShowResetPasswordAlert] = useState(location.state && location.state.notify ? true : false);

    const [verificationCodeSent, isVerificationCodeSent] = useState(false);
    const [verificationCode, setVerificationCode] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const [isCodeLoading, setIsCodeLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [showPasswordUpdatedPopup, setShowPasswordUpdatedPopup] = useState(false);

    //const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const [resendTimer, setResendTimer] = useState(0); // Timer for resending code
    const [resendDisabled, setResendDisabled] = useState(false); // Disable resend button during timer

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
    };

    const handleVerificationCodeChange = (e) => {
        setVerificationCode(e.target.value);
    };

    const handleCloseError = () => {
        setShowError(false);
        setErrorMessage('');
    };

    const sendCode = async () => {
        setIsCodeLoading(true);

        try {
            const response = await fetch(API_URL + '/user/verification', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            // Check if the response is OK
            if (!response.ok) {
                if (response.status >= 500) {
                    setErrorMessage('Server error. Please try again later.'); // Specific 5xx error
                    setShowError(true);
                    setIsCodeLoading(false);
                    return;
                }
                else {
                    setErrorMessage('Email not registered. Please check and try again.');
                    setShowError(true);
                    setIsCodeLoading(false);
                    return;
                }
            }

            if (response.status === 200) {
                isVerificationCodeSent(true);
                setIsCodeLoading(false);

                // Start the resend timer
                setResendTimer(30);
                setResendDisabled(true);

                return;
            }
        } catch (error) {
            // Handle errors

            // Update UI state for error handling
            setErrorMessage('An error occurred. Please try after some time.');
            setShowError(true);
            setIsCodeLoading(false);

            return;
        }
    };

    const submitResetPassword = async () => {
        setIsLoading(true);

        /*
        // Generate a salt (you can adjust the salt rounds for security)
        const saltRounds = 10;
        const salt = bcrypt.genSaltSync(saltRounds);
        //console.log("Salt: " + salt);

        // Hash the password with the salt
        const hash = bcrypt.hashSync(password, salt);
        //console.log("Hash: " + hash);
        */

        const request = {
            email: email,
            // salt: salt,
            // password: hash,
            password: password,
            verificationCode: verificationCode
        }

        try {
            const response = await axios.post(API_URL + `/user/reset`, request, {
                headers: {
                    'Content-Type': 'application/json', // Set the content type to JSON
                },
            });

            console.log(response.data);
            console.log(response.status);
            console.log(response.ok);


            if (response.status === 200) {
                setShowPasswordUpdatedPopup(true);
                setIsLoading(false);
                return;
            }

            // Handle error
            if (!response.ok) {
                if (response.status >= 500) {
                    console.log(response.data.message);
                    if (response.data.message === 'Invalid verification code') {
                        setErrorMessage('Invalid Confirmation Code.');
                    } else {
                        setErrorMessage('Server error. Please try again later.'); // Specific 5xx error
                    }
                    setShowError(true);
                    setIsLoading(false);
                    return;
                }
                else {
                    console.log(response.data.message);
                    if (response.data.message === 'Invalid verification code') {
                        setErrorMessage('Invalid Confirmation Code.');
                    } else {
                        setErrorMessage('Email not registered. Please check and try again.');
                    }
                    setShowError(true);
                    setIsLoading(false);
                    return;
                }
            }
        } catch (error) {
            // Handle errors
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
            }

            if (error.response.data.error === 'Invalid verification code') {
                setErrorMessage('Invalid Verification Code');
            } else {
                setErrorMessage('An error occurred. Please try after some time.');
            }

            setShowError(true);
            setIsLoading(false);

            return;
        }
    };

    const handleLogin = () => {
        setShowPasswordUpdatedPopup(false);
        navigate('/login', {
            state: {
                email: email
            },
        });
    }

    // Resend code timer effect
    useEffect(() => {
        let interval;
        if (resendTimer > 0) {
            interval = setInterval(() => {
                setResendTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        } else if (resendDisabled) {
            setResendDisabled(false);
        }
        return () => clearInterval(interval);
    }, [resendTimer, resendDisabled]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar />
            <main style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
                <div style={{
                    padding: '20px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    minWidth: '350px',
                    backgroundColor: 'white'
                }}>
                    <h1 style={{ textAlign: "center" }}>Reset Password</h1>

                    <div>
                        <div>
                            <label htmlFor="email">Mobile</label>
                            <input
                                type="text"
                                id="email"
                                value={email}
                                onChange={handleEmailChange}
                                required
                            />
                        </div>
                        {/* <br></br> */}
                        <div hidden={!verificationCodeSent} style={{ paddingTop: '10px' }}>
                            <label htmlFor="email">New Password</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={handlePasswordChange}
                                required
                            />
                        </div>
                        {/* <br></br> */}
                        <div hidden={!verificationCodeSent} style={{ paddingTop: '10px' }}>
                            <label htmlFor="email">Confirm Password</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={handleConfirmPasswordChange}
                                required
                            />
                            {password.length > 0 && confirmPassword.length > 0 && password !== confirmPassword && (
                                <small style={{ color: 'red' }}>Password does not match</small>
                            )}
                        </div>
                        {/* <br></br> */}
                        <div hidden={!verificationCodeSent} style={{ paddingTop: '10px' }}>
                            <label htmlFor="email">Verification Code</label>
                            <input
                                type="text"
                                id="passcode"
                                value={verificationCode}
                                onChange={handleVerificationCodeChange}
                                placeholder="Enter the code sent to your email"
                                required
                            />
                        </div>
                        <div className="popup-buttons">
                            <div hidden={verificationCodeSent}>
                                <button
                                    hidden={verificationCodeSent}
                                    className="submit-button"
                                    style={{ fontWeight: "bold" }}
                                    onClick={sendCode}
                                    disabled={
                                        // !emailPattern.test(email) ||
                                        isLoading ||
                                        !email}>
                                    {isCodeLoading ? <div className="spinner"></div> : 'Send Verification Code'}
                                </button>
                            </div>

                            <div hidden={!verificationCodeSent} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <button
                                    hidden={!verificationCodeSent}
                                    className="submit-button"
                                    style={{ fontWeight: "bold" }}
                                    onClick={submitResetPassword}
                                    disabled={
                                        // !emailPattern.test(email) ||
                                        isLoading ||
                                        !email ||
                                        !password ||
                                        password !== confirmPassword ||
                                        !verificationCode ||
                                        verificationCode.length < 6}>
                                    {isLoading ? <div className="spinner"></div> : 'Submit'}
                                </button>
                                {/* <div hidden={!verificationCodeSent} style={{ textAlign: 'center', marginTop: '5px' }}>
                                {resendDisabled && (
                                    <p style={{ fontSize: '16px' }}>
                                        Didn't receive the code? Resend code in <strong>{resendTimer}</strong>
                                    </p>
                                )}
                                {!resendDisabled && (
                                    <p 
                                        hidden={isCodeLoading}
                                        style={{ fontSize: '16px', color: 'red', textUnderlineOffset: '5px' }}>
                                        <a href="#" onClick={sendCode}>Resend Verification Code</a>
                                    </p>
                                )}
                            </div> */}
                                <div hidden={!verificationCodeSent} style={{ textAlign: 'center', marginTop: '5px' }}>
                                    {resendDisabled && (
                                        <p style={{ fontSize: '16px' }}>
                                            Didn't receive the code? Resend code in <strong>{resendTimer}</strong>
                                        </p>
                                    )}
                                    {!resendDisabled && (
                                        <div style={{ position: 'relative' }}>
                                            {isCodeLoading && (
                                                <div style={{ paddingTop: '15px' }}>
                                                    <div className="spinner"></div>
                                                    {/* <span>Sending...</span> */}
                                                </div>
                                            )}
                                            <p
                                                hidden={isCodeLoading}
                                                style={{ fontSize: '16px', color: isCodeLoading ? 'gray' : 'red', textUnderlineOffset: '5px', pointerEvents: isCodeLoading ? 'none' : 'auto' }}>
                                                <a href="#" onClick={isCodeLoading ? null : sendCode} style={{ textDecoration: isCodeLoading ? 'none' : 'underline' }}>
                                                    Resend Verification Code
                                                </a>
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <br></br>
                        <p hidden={verificationCodeSent} style={{ textAlign: "center", textDecoration: "underline", textUnderlineOffset: '3px' }}><a href="/login">Cancel</a></p>
                        <p hidden={verificationCodeSent} style={{ textAlign: "center" }}>Don't have an account? Click <a href="/register" style={{textDecoration: "underline", textUnderlineOffset: '3px'}}>here</a> to register.</p>
                    </div>

                    {showError && errorMessage && (
                        <div className="popup-overlay">
                            <div className="popup-container">
                                <h3>Error</h3>
                                <p>{errorMessage}</p>
                                <button
                                    className="submit-popup-button"
                                    onClick={handleCloseError}
                                >OK</button>
                            </div>
                        </div>
                    )}

                    {showPasswordUpdatedPopup && (
                        <div className="popup-overlay">
                            <div className="popup-container">
                                <h3>Password Updated</h3>
                                Your password has been updated successfully! Please log in to continue.
                                <div className="popup-buttons" style={{ marginBottom: '15px' }}>
                                    <button
                                        className="submit-popup-button"
                                        onClick={() => handleLogin()}
                                    >OK</button>
                                </div>
                            </div>
                        </div>
                    )}

                    {showResetPasswordAlert && (
                        <div className="popup-overlay">
                            <div className="popup-container">
                                <h3>Reset Password</h3>
                                Please reset your password to continue.
                                <div className="popup-buttons" style={{ marginBottom: '15px' }}>
                                    <button
                                        className="submit-popup-button"
                                        onClick={() => setShowResetPasswordAlert(false)}
                                    >OK</button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default ResetPassword;
